import { FC } from "react";
import { splitAmountFloor } from "shared/utils";
import { getMinTier } from "../model/minTier";
import type { Raffle } from "../model/types";
import { ConditionTile } from "./ConditionTile";
import type { ConditionTileProps } from "./ConditionTile";
import { RaffleTimeline } from "./RaffleTimeline";

import styles from "./RaffleConditions.module.css";

interface Props {
  raffle: Raffle;
}

const VISIBILITY_LABELS: Record<Raffle["visibility"], string> = {
  open: "Open",
  private: "Private (by code)",
};

// Пул делится между победителями поровну, доля округляется вниз.
const getPrizePerWinner = ({ prize_pool_usdt, winners_count }: Raffle) =>
  splitAmountFloor(Number(prize_pool_usdt), winners_count);

const getTierLabel = (raffle: Raffle): string => {
  const minTier = getMinTier(raffle.allowed_participant_tiers);
  return minTier ? `${minTier.display_name} and higher` : "Any";
};

const getTiles = (raffle: Raffle): ConditionTileProps[] => [
  {
    icon: "coins",
    label: "Prize pool",
    value: `${raffle.prize_pool_usdt} USDT`,
  },
  { icon: "trophy", label: "Winners", value: String(raffle.winners_count) },
  {
    icon: "coins",
    label: "Prize per winner",
    value: `${getPrizePerWinner(raffle)} USDT`,
  },
  {
    icon: "people",
    label: "Participants",
    value: String(raffle.participants_count),
  },
  { icon: "chart", label: "Min. volume", value: `${raffle.volume_usdt} USDT` },
  {
    icon: "link",
    label: "Pairs",
    value: raffle.symbols.join(", "),
    list: raffle.symbols,
  },
  {
    icon: "award",
    label: "Status",
    value: getTierLabel(raffle),
  },
  {
    icon: "layers",
    label: "Type",
    value: VISIBILITY_LABELS[raffle.visibility],
    accent: raffle.visibility === "open",
  },
];

export const RaffleConditions: FC<Props> = ({ raffle }) => (
  <div className={styles.conditions}>
    <div className={styles.grid}>
      {getTiles(raffle).map((tile) => (
        <ConditionTile key={tile.label} {...tile} />
      ))}
    </div>
    <RaffleTimeline raffle={raffle} />
  </div>
);
